interface DocumentIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const DocumentIcon: React.FC<DocumentIconProps> = ({
  width = 100,
  height = 100,
  fill = "#E1E1E1"
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.667 16.6668C16.667 14.4567 17.545 12.3371 19.1078 10.7743C20.6706 9.21147 22.7902 8.3335 25.0003 8.3335H58.3337C59.4386 8.33373 60.4983 8.77287 61.2795 9.55433L82.1128 30.3877C82.8943 31.1689 83.3334 32.2285 83.3337 33.3335V83.3335C83.3337 85.5436 82.4557 87.6633 80.8929 89.2261C79.3301 90.7889 77.2105 91.6668 75.0003 91.6668H25.0003C22.7902 91.6668 20.6706 90.7889 19.1078 89.2261C17.545 87.6633 16.667 85.5436 16.667 83.3335V16.6668ZM73.2753 33.3335L58.3337 18.3918V33.3335H73.2753ZM50.0003 16.6668H25.0003V83.3335H75.0003V41.6668H54.167C53.0619 41.6668 52.0021 41.2278 51.2207 40.4464C50.4393 39.665 50.0003 38.6052 50.0003 37.5002V16.6668ZM33.3337 54.1668C33.3337 53.0618 33.7726 52.002 34.554 51.2206C35.3354 50.4392 36.3953 50.0002 37.5003 50.0002H62.5003C63.6054 50.0002 64.6652 50.4392 65.4466 51.2206C66.228 52.002 66.667 53.0618 66.667 54.1668C66.667 55.2719 66.228 56.3317 65.4466 57.1131C64.6652 57.8945 63.6054 58.3335 62.5003 58.3335H37.5003C36.3953 58.3335 35.3354 57.8945 34.554 57.1131C33.7726 56.3317 33.3337 55.2719 33.3337 54.1668ZM33.3337 70.8335C33.3337 69.7284 33.7726 68.6686 34.554 67.8872C35.3354 67.1058 36.3953 66.6668 37.5003 66.6668H62.5003C63.6054 66.6668 64.6652 67.1058 65.4466 67.8872C66.228 68.6686 66.667 69.7284 66.667 70.8335C66.667 71.9386 66.228 72.9984 65.4466 73.7798C64.6652 74.5612 63.6054 75.0002 62.5003 75.0002H37.5003C36.3953 75.0002 35.3354 74.5612 34.554 73.7798C33.7726 72.9984 33.3337 71.9386 33.3337 70.8335Z"
        fill={fill}
      />
    </svg>
  );
};

export default DocumentIcon;
